// extracted by mini-css-extract-plugin
module.exports = {"option":"option_option__qftuX","optionAmount":"option_optionAmount__TFOPj","optionInput":"option_optionInput__5dFAX","optionSelected":"option_optionSelected__UUAkE"};